import { useState } from "react";
import { FaQuestion, FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Add_Product_Button() {
  const [modalStep, setModalStep] = useState(null);
  const [pendingStatus, setPendingStatus] = useState("");
  const [successType, setSuccessType] = useState("");
  const Nav = useNavigate();
  const openActiveConfirm = () => {
    setPendingStatus("Active");
    setModalStep("confirm-active");
  };

  const openOwnerConfirm = () => {
    setPendingStatus("No Owner");
    setModalStep("confirm-owner");
  };

  const handleConfirm = () => {
    if (modalStep === "confirm-active") {
      setSuccessType("active");
    } else if (modalStep === "confirm-owner") {
      setSuccessType("noOwner");
    }
    setModalStep("success");
  };

  const handleCloseSuccess = () => {
    setModalStep(null);
    Nav("/admin-dashboard/save-product");
  };

  return (
    <div>
      <div className="w-full gap-3 flex justify-end mt-5">
        <button
          onClick={openOwnerConfirm}
          className="border border-red-600 text-red-600 font-semibold px-5 rounded cursor-pointer outline-none hover:border-red-700 py-1"
        >
          Skip For Now
        </button>
        <button
          onClick={openActiveConfirm}
          className="bg-red-600 text-white px-5 rounded cursor-pointer outline-none hover:bg-red-700 py-1"
        >
          Add Product
        </button>
      </div>

      {modalStep === "confirm-active" && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg text-center shadow-lg w-80">
            <div className="flex justify-center mb-4">
              <div className="bg-red-500 text-white rounded-full w-14 h-14 flex items-center justify-center text-2xl">
                <FaCheck />
              </div>
            </div>
            <p className="text-base font-medium px-4 mb-4">
              Are you sure you want to add this product with Active Status?
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="border border-red-500 text-red-500 px-6 py-1 rounded hover:bg-red-100"
                onClick={openOwnerConfirm}
              >
                Go Back
              </button>
              <button
                className="bg-red-600 text-white px-10 py-1 rounded hover:bg-red-700"
                onClick={handleConfirm}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {modalStep === "confirm-owner" && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg text-center shadow-lg w-1/3">
            <div className="flex justify-center mb-4">
              <div className="bg-red-500 text-white rounded-full w-14 h-14 flex items-center justify-center text-2xl">
                <FaQuestion />
              </div>
            </div>
            <p className="text-base font-medium px-4 mb-4">
              Are you sure you want to add this product without assigning a
              Product Owner?
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="border border-red-500 text-red-500 px-6 py-1 rounded hover:bg-red-100"
                onClick={() => setModalStep(null)}
              >
                Go Back
              </button>
              <button
                className="bg-red-600 text-white px-6 py-1 rounded hover:bg-red-700"
                onClick={handleConfirm}
              >
                Yes, Add Now
              </button>
            </div>
          </div>
        </div>
      )}

      {modalStep === "success" && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg text-center shadow-lg w-80">
            <div className="flex justify-center mb-4">
              <div className="bg-red-500 text-white rounded-full w-14 h-14 flex items-center justify-center text-2xl">
                <FaCheck />
              </div>
            </div>
            <p className="text-base font-medium px-4 mb-4">
              {successType === "active" &&
                "Product has been added successfully!"}
              {successType === "noOwner" &&
                "Product has been added successfully!"}
            </p>
            <button
              className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700"
              onClick={handleCloseSuccess}
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Add_Product_Button;
